import { render, staticRenderFns } from "./ChamberNormativeBase.vue?vue&type=template&id=3a80c75d&scoped=true&"
import script from "./ChamberNormativeBase.vue?vue&type=script&lang=js&"
export * from "./ChamberNormativeBase.vue?vue&type=script&lang=js&"
import style0 from "./ChamberNormativeBase.vue?vue&type=style&index=0&id=3a80c75d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a80c75d",
  null
  
)

export default component.exports